/**
 * We take the approach of organizing each “cast member” in a scene within its own file.
 * This is a choice and isn’t required, but it does isolate internal changes/enhancements
 * to these specific “characters.”
 */
import {Mesh, MeshToonMaterial, RingGeometry, ExtrudeGeometry, Group, DoubleSide, Shape} from 'three'
/**
 * The use of a JavaScript “class” is also a design choice.
 */

 class plasticRings {
     constructor(color){
         this.group = new Group()
         this.group.materials = []

        const length = 1.1, width = 1.6;
        const shape = new Shape();
        shape.moveTo( -length/2, -width/2 );
        shape.lineTo( -length/2, width/2 );
        shape.lineTo( length/2, width/2 );
        shape.lineTo( length/2, -width/2 );
        shape.lineTo( -length/2, -width/2 );
        this.geometry = new ExtrudeGeometry(shape,{steps: 1, depth: 0.1, bevelEnabled: false});
        this.clearMaterial = new MeshToonMaterial({ color, opacity: 0.0, transparent: true });
        this.clickable = new Mesh(this.geometry, this.clearMaterial)
        this.group.add(this.clickable)

        this.ringMaterial = new MeshToonMaterial({ color });
        this.ringMaterial.side = DoubleSide;
        this.group.materials.push(this.ringMaterial)
        this.geometry = new RingGeometry(0.2, 0.3, 10, 3, 0, 6.3);

        this.circle1 = new Mesh(this.geometry, this.ringMaterial)
        this.circle1.position.set(-0.25,-0.5,0)
        this.group.add(this.circle1);

        this.circle2 = new Mesh(this.geometry, this.ringMaterial)
        this.circle2.position.set(0.25,-0.5,0)
        this.group.add(this.circle2);

        this.circle3 = new Mesh(this.geometry, this.ringMaterial)
        this.circle3.position.set(-0.25,0,0)
        this.group.add(this.circle3);

        this.circle4 = new Mesh(this.geometry, this.ringMaterial)
        this.circle4.position.set(0.25,0,0)
        this.group.add(this.circle4);

        this.circle5 = new Mesh(this.geometry, this.ringMaterial)
        this.circle5.position.set(-0.25,0.5,0)
        this.group.add(this.circle5);

        this.circle6 = new Mesh(this.geometry, this.ringMaterial)
        this.circle6.position.set(0.25,0.5,0)
        this.group.add(this.circle6);

        this.group.rotation.x = Math.random() * Math.PI / 2
        this.group.rotation.y = Math.random() * Math.PI / 2
        this.group.rotation.z = Math.random() * Math.PI / 2

        this.group.scale.set(0.8, 0.8, 0.8)
     }
    }

 export default plasticRings